import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search, Globe } from "lucide-react";
import axios from "axios";

const API = "/api";

export default function Countries() {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/countries/browse`).then(res => {
      setCountries(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = countries.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2" style={{ fontFamily: 'Poppins' }} data-testid="countries-title">
            <Globe className="inline-block mr-3 text-[#FFC928]" size={32} />
            {t("countries.title")}
          </h1>
          <p className="text-[#94A3B8] text-sm">{t("countries.subtitle", { count: countries.length })}</p>
        </div>

        <div className="relative mb-8 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" size={18} />
          <input
            data-testid="country-search"
            type="text"
            placeholder={t("countries.searchPlaceholder")}
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-[#0F172A] border border-white/[0.06] rounded-xl text-white placeholder-[#94A3B8]/60 focus:outline-none focus:ring-2 focus:ring-[#FFC928]/20 text-sm"
          />
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-3" data-testid="countries-grid">
            {filtered.map(country => (
              <Link
                key={country.id}
                to={`/?country=${country.id}`}
                data-testid={`country-${country.id}`}
                className="group flex flex-col items-center p-3 bg-[#0F172A]/50 border border-white/[0.06] rounded-xl hover:border-[#FFC928]/30 hover:bg-[#0F172A] transition-all"
              >
                <img
                  src={country.flag_url?.replace('/w40/', '/w80/') || `https://flagcdn.com/w80/${country.name.toLowerCase().slice(0,2)}.png`}
                  alt={country.name}
                  className="w-12 h-8 object-cover rounded shadow-md mb-2 group-hover:scale-110 transition-transform"
                  loading="lazy"
                  onError={e => { e.target.style.display = 'none'; }}
                />
                <span className="text-xs text-center text-[#94A3B8] group-hover:text-white transition-colors leading-tight font-medium">
                  {country.name}
                </span>
                {country.channel_count > 0 && (
                  <span className="text-[10px] text-[#94A3B8]/60 mt-0.5">{country.channel_count} {t("countries.channels")}</span>
                )}
              </Link>
            ))}
          </div>
        )}

        {!loading && filtered.length === 0 && (
          <div className="text-center py-20 text-[#94A3B8]">{t("countries.noResults", { query: search })}</div>
        )}
      </div>
    </div>
  );
}
